import {AIContentStatus} from "../components/GageGenerateContent/GageGenerateContent";
import {UseMutationResult} from "react-query";
import {AIContent} from "../types/AIContent";

export function getAIContentStatus(mutation: UseMutationResult<AIContent, unknown, any, unknown>): AIContentStatus | null {
  // TODO: Remove this once the AI response no longer intemittently returns an array
  if (Array.isArray(mutation.data?.content)) return 'error';

  if (mutation.isError || mutation.data?.content === null) return 'error';
  if (mutation.data?.content) return 'success';
  return null;
}